export enum Feature {
  HOW_4690_MEINPLUS_DEPOSIT_GUARANTEE_PROMO = 'HOW_4690_MEINPLUS_DEPOSIT_GUARANTEE_PROMO',
  ADAC_ASSIGMENT = 'ADAC_ASSIGMENT',
  ADAC_ASSIGMENT_FORCE_MODAL_PREVIEW = 'ADAC_ASSIGMENT_FORCE_MODAL_PREVIEW',
  HOW_4425_UPSELL_MODAL_PREVIEW = 'HOW_4425_UPSELL_MODAL_PREVIEW',
  FEATURE_EXAMPLE = 'FEATURE_EXAMPLE',
  WOHNEN_PLUS_LIGHT = 'WOHNEN_PLUS_LIGHT',
  PRIORITIZE_WOHNEN_PLUS_LIGHT = 'PRIORITIZE_WOHNEN_PLUS_LIGHT',
  BLOCK_WOHNEN_PLUS_LIGHT_UPSELL_ANDROID = 'BLOCK_WOHNEN_PLUS_LIGHT_UPSELL_ANDROID',
  BIZ_9847_ANDROID_EXTERNAL_TRANSACTION_TOKEN = 'BIZ_9847_ANDROID_EXTERNAL_TRANSACTION_TOKEN',
  BIZ_9816_MIETCHECK_WIDGET = 'BIZ_9816_MIETCHECK_WIDGET',
  BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT = 'BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT',
  PM_1367_RENTRACTION_TASK_MANAGEMENT = 'PM_1367_RENTRACTION_TASK_MANAGEMENT',
}

export interface FeatureSwitch {
  feature: Feature;
  enabled: boolean;
}

export interface FeatureSwitches {
  features: FeatureSwitch[];
}
